export default __webpack_public_path__ + "static/media/cool-background.0ac5895d.jpg";